import { SAMPLE_QUOTE } from './sampleQuote';

const BOOKING_PASSENGERS = [
  { first_name: 'Sarah', last_name: 'Mitchell' },
  { first_name: 'Arthur', last_name: 'Taylor' },
  { first_name: 'Laura', last_name: 'Per\u00e9z' },
  { first_name: 'Matthew', last_name: 'Johnson' },
  { first_name: 'Wei', last_name: 'Chan' },
  { first_name: 'Emma', last_name: 'Wright' },
];

export const BOOKING_SECURED_SAMPLE = {
    "quote": {
        "created_by": "bedf3852-a2f2-4a7c-885c-4cce9d6ad067",
        "status": "ACCEPTED",
        "card_fee": null,
        "client_id": "758cbb92-56b3-4421-a22e-862d637325f5",
        "arrival_airport": "KTEX",
        "payment_status": "CAPTURED",
        "operator_cost": null,
        "departure_airport": "KTEB",
        "departure_date": "2026-05-01T03:30:00",
        "created_at": "2026-04-15T02:31:53.673658+00:00",
        "broker_margin": 5.33,
        "quote_number": "TR-1776220312440",
        "return_date": null,
        "updated_at": "2026-04-15T05:00:12.050355+00:00",
        "platform_fee": 0.08,
        "broker_org_id": "94d76474-c055-4882-ab9d-651c29cf5fb9",
        "is_round_trip": false,
        "flight_cost": null,
        "note_to_client": "",
        "is_multi_leg": false,
        "federal_excise_tax": 0,
        "passenger_count": 1,
        "segment_tax": null,
        "quote_id": "5e096109-0655-4099-ba78-5995c7bdf1b0",
        "total_due": 5.41,
        "client": {
            "address1": "123 East 85th Street, Apt 5G",
            "email": "kgatchalian@trustjet.ai",
            "updated_at": "2026-04-09T12:32:53.186776+00:00",
            "address2": "add2",
            "passport_num": null,
            "client_id": "758cbb92-56b3-4421-a22e-862d637325f5",
            "city": "New York City",
            "nationality": null,
            "state": "New York",
            "company_name": "NewCompany",
            "first_name": "Kervin",
            "country": "country",
            "company_address": null,
            "zip_code": "123",
            "broker_id": "bedf3852-a2f2-4a7c-885c-4cce9d6ad067",
            "last_name": "Kervin",
            "contact_numbers": [
                "+112345678"
            ],
            "payment_info": {
                "stripe": {
                    "stripe_customer_id": "cus_TveFrMI18U1aSR"
                },
                "mxmerchant": {
                    "customer_id": 10000001652878,
                    "customer_number": "758cbb92-56b3-4421-a22e-862d637325f5"
                }
            },
            "birth_date": "1990-12-12T00:00:00",
            "created_at": "2026-02-06T11:11:13.624849+00:00"
        },
        "bid_items": [
            {
                "quote_bid_item_id": "40d1fd5e-dc9c-4f41-a8e3-5cbde60f9c0e",
                "created_at": "2026-04-15T02:31:54.965127+00:00",
                "updated_at": "2026-04-15T02:31:54.965127+00:00",
                "bid_id": "553fc839-a0bd-4386-ba2b-3ac32c435909",
                "quote_id": "5e096109-0655-4099-ba78-5995c7bdf1b0",
                "bid": {
                    "departure_date": "2026-05-01T03:30:00",
                    "valid_until": "2026-04-30T00:00:00",
                    "updated_at": "2026-04-15T02:31:45.918573",
                    "return_date": null,
                    "sent_at": null,
                    "passenger_count": 1,
                    "viewed_at": null,
                    "leg_itinerary": [
                        {
                            "pax": 1,
                            "departure_date": "2026-05-01T03:30:00.000Z",
                            "arrival_address": null,
                            "arrival_airport": "KTEX",
                            "departure_address": null,
                            "departure_airport": "KTEB"
                        }
                    ],
                    "bid_id": "553fc839-a0bd-4386-ba2b-3ac32c435909",
                    "client_name": "Kervin Kervin",
                    "baggage_requirements": "",
                    "accepted_at": null,
                    "client_email": "kgatchalian@trustjet.ai",
                    "special_requests": "",
                    "notes": "",
                    "broker_id": "bedf3852-a2f2-4a7c-885c-4cce9d6ad067",
                    "client_phone": "",
                    "status": "DRAFT",
                    "message_id": null,
                    "trip_number": "T673362",
                    "created_by": "bedf3852-a2f2-4a7c-885c-4cce9d6ad067",
                    "departure_airport": "KTEB",
                    "total_amount": 5.41,
                    "broker_org_id": "94d76474-c055-4882-ab9d-651c29cf5fb9",
                    "arrival_airport": "KTEX",
                    "currency": "USD",
                    "created_at": "2026-04-15T02:31:45.918573",
                    "bid_options": [
                        {
                            "operator_id": "28fcb9b8-46b8-442b-b328-7c0e79faae59",
                            "total_price": 0,
                            "estimated_flight_time": 0,
                            "platform_fee": 0,
                            "aircraft_id": "00083cb7-4596-420f-8946-b67cb5b4caf2",
                            "broker_markup": 0,
                            "aircraft_features": {
                                "beds": 1,
                                "wifi": false,
                                "entertainment": false
                            },
                            "status": "ACCEPTED",
                            "bid_id": "553fc839-a0bd-4386-ba2b-3ac32c435909",
                            "fuel_cost": 0,
                            "final_price": 5.41,
                            "shortlisted": true,
                            "bid_option_id": "775022f6-c2e7-4f77-86ca-707edd2bd9df",
                            "landing_fees": 0,
                            "is_recommended": true,
                            "created_at": "2026-04-15T02:31:49.387623",
                            "crew_fees": 0,
                            "recommendation_reason": ".",
                            "updated_at": "2026-04-15T02:31:49.387623",
                            "catering_cost": 0,
                            "availability_confirmed": true,
                            "federal_excise_tax": 0,
                            "base_price": 0,
                            "ground_transport": 0,
                            "risk_level": "LOW",
                            "segment_tax": 5.2,
                            "other_fees": 0,
                            "trust_score": 0,
                            "operator_cost": 0,
                            "operator": {
                                "base_airport": null,
                                "email": "jimhunt@eagleairmed.com",
                                "external_sources": {},
                                "trust_score": 96.38,
                                "business_started_date": "1994-01-11T00:00:00",
                                "website": "http://www.stanstednews.com/privacy.html",
                                "rating_tiers": "Pinnacle",
                                "trust_score_updated_at": "2026-01-09T00:50:03.316776",
                                "argus_rating": "No",
                                "faa_operator_name": "GUARDIAN FLIGHT, LLC.",
                                "financial_health_score": 100,
                                "wyvern_rating": "No",
                                "faa_dsgn_code": "G1IA",
                                "dba_name": null,
                                "aoc_part135": "G1IA720A (Guardian Flight LLC)",
                                "faa_ceo": "BURNS, CHRISTOPHER",
                                "operator_id": "28fcb9b8-46b8-442b-b328-7c0e79faae59",
                                "certificate_number": "G1IA720A",
                                "regulatory_status": "COMPLIANT",
                                "is_bao": "No",
                                "faa_city": "LEWISVILLE",
                                "ops_specs": null,
                                "is_verified": true,
                                "acsf_ias": "No",
                                "faa_state": "TX",
                                "name": "Guardian Flight, Llc.",
                                "created_at": "2025-11-20T15:54:53.284428",
                                "telephone": "+1 435 678 3222",
                                "faa_pic_captains": "235"
                            },
                            "aircraft": {
                                "range_nautical_miles": null,
                                "hourly_rate": null,
                                "manufacturer": null,
                                "cruise_speed_kts": null,
                                "cruise_speed_knots": null,
                                "model": null,
                                "jetnet_lookup_attempted_at": null,
                                "current_status": "AVAILABLE",
                                "created_at": "2025-12-01T01:24:50.216587",
                                "image_urls": [
                                    "/static/photos/N399WS/0.jpg",
                                    "/static/photos/N399WS/1.jpg",
                                    "/static/photos/N399WS/10.jpg",
                                    "/static/photos/N399WS/11.jpg",
                                    "/static/photos/N399WS/12.jpg",
                                    "/static/photos/N399WS/13.jpg",
                                    "/static/photos/N399WS/14.jpg",
                                    "/static/photos/N399WS/15.jpg",
                                    "/static/photos/N399WS/16.jpg",
                                    "/static/photos/N399WS/17.jpg",
                                    "/static/photos/N399WS/18.jpg",
                                    "/static/photos/N399WS/19.jpg",
                                    "/static/photos/N399WS/2.jpg",
                                    "/static/photos/N399WS/20.jpg",
                                    "/static/photos/N399WS/21.jpg",
                                    "/static/photos/N399WS/3.jpg",
                                    "/static/photos/N399WS/4.jpg",
                                    "/static/photos/N399WS/5.jpg",
                                    "/static/photos/N399WS/6.jpg",
                                    "/static/photos/N399WS/7.jpg",
                                    "/static/photos/N399WS/8.jpg",
                                    "/static/photos/N399WS/9.jpg"
                                ],
                                "jetnet_exists": false,
                                "aircraft_id": "00083cb7-4596-420f-8946-b67cb5b4caf2",
                                "operator_id": "28fcb9b8-46b8-442b-b328-7c0e79faae59",
                                "last_maintenance": null,
                                "mfr_year": null,
                                "banner_image_url": null,
                                "jetnet_details_fetched_at": "2026-01-15T02:22:33.502107+00:00",
                                "tail_number": "N399WS",
                                "year": null,
                                "aw_date": null,
                                "description": null,
                                "aircraft_make_model_id": "8f4ebbfe-7e54-4bff-aae5-53d668f27dca",
                                "make_model": "BE-90-C90A",
                                "serial_number": "LJ-1547",
                                "next_maintenance_due": null,
                                "registered_owner": null,
                                "max_passengers": null,
                                "aircraft_type": null,
                                "insurance_expiry": null,
                                "registered_owner_state": null,
                                "range_nm": null,
                                "passenger_capacity": null,
                                "home_base": null,
                                "fractional_owner": false,
                                "aircraft_features": null,
                                "aircraft_amenities": null
                            }
                        }
                    ]
                }
            }
        ],
        "acceptedBid": {
            "departure_date": "2026-05-01T03:30:00",
            "valid_until": "2026-04-30T00:00:00",
            "updated_at": "2026-04-15T02:31:45.918573",
            "return_date": null,
            "sent_at": null,
            "passenger_count": 1,
            "viewed_at": null,
            "leg_itinerary": [
                {
                    "pax": 1,
                    "departure_date": "2026-05-01T03:30:00.000Z",
                    "arrival_address": null,
                    "arrival_airport": "KTEX",
                    "departure_address": null,
                    "departure_airport": "KTEB"
                }
            ],
            "bid_id": "553fc839-a0bd-4386-ba2b-3ac32c435909",
            "client_name": "Kervin Kervin",
            "baggage_requirements": "",
            "accepted_at": null,
            "client_email": "kgatchalian@trustjet.ai",
            "special_requests": "",
            "notes": "",
            "broker_id": "bedf3852-a2f2-4a7c-885c-4cce9d6ad067",
            "client_phone": "",
            "status": "DRAFT",
            "message_id": null,
            "trip_number": "T673362",
            "created_by": "bedf3852-a2f2-4a7c-885c-4cce9d6ad067",
            "departure_airport": "KTEB",
            "total_amount": 5.41,
            "broker_org_id": "94d76474-c055-4882-ab9d-651c29cf5fb9",
            "arrival_airport": "KTEX",
            "currency": "USD",
            "created_at": "2026-04-15T02:31:45.918573",
            "bid_options": [
                {
                    "operator_id": "28fcb9b8-46b8-442b-b328-7c0e79faae59",
                    "total_price": 0,
                    "estimated_flight_time": 0,
                    "platform_fee": 0,
                    "aircraft_id": "00083cb7-4596-420f-8946-b67cb5b4caf2",
                    "broker_markup": 0,
                    "aircraft_features": {
                        "beds": 1,
                        "wifi": false,
                        "entertainment": false
                    },
                    "status": "ACCEPTED",
                    "bid_id": "553fc839-a0bd-4386-ba2b-3ac32c435909",
                    "fuel_cost": 0,
                    "final_price": 5.41,
                    "shortlisted": true,
                    "bid_option_id": "775022f6-c2e7-4f77-86ca-707edd2bd9df",
                    "landing_fees": 0,
                    "is_recommended": true,
                    "created_at": "2026-04-15T02:31:49.387623",
                    "crew_fees": 0,
                    "recommendation_reason": ".",
                    "updated_at": "2026-04-15T02:31:49.387623",
                    "catering_cost": 0,
                    "availability_confirmed": true,
                    "federal_excise_tax": 0,
                    "base_price": 0,
                    "ground_transport": 0,
                    "risk_level": "LOW",
                    "segment_tax": 5.2,
                    "other_fees": 0,
                    "trust_score": 0,
                    "operator_cost": 0,
                    "operator": {
                        "base_airport": null,
                        "email": "jimhunt@eagleairmed.com",
                        "external_sources": {},
                        "trust_score": 96.38,
                        "business_started_date": "1994-01-11T00:00:00",
                        "website": "http://www.stanstednews.com/privacy.html",
                        "rating_tiers": "Pinnacle",
                        "trust_score_updated_at": "2026-01-09T00:50:03.316776",
                        "argus_rating": "No",
                        "faa_operator_name": "GUARDIAN FLIGHT, LLC.",
                        "financial_health_score": 100,
                        "wyvern_rating": "No",
                        "faa_dsgn_code": "G1IA",
                        "dba_name": null,
                        "aoc_part135": "G1IA720A (Guardian Flight LLC)",
                        "faa_ceo": "BURNS, CHRISTOPHER",
                        "operator_id": "28fcb9b8-46b8-442b-b328-7c0e79faae59",
                        "certificate_number": "G1IA720A",
                        "regulatory_status": "COMPLIANT",
                        "is_bao": "No",
                        "faa_city": "LEWISVILLE",
                        "ops_specs": null,
                        "is_verified": true,
                        "acsf_ias": "No",
                        "faa_state": "TX",
                        "name": "Guardian Flight, Llc.",
                        "created_at": "2025-11-20T15:54:53.284428",
                        "telephone": "+1 435 678 3222",
                        "faa_pic_captains": "235"
                    },
                    "aircraft": {
                        "range_nautical_miles": null,
                        "hourly_rate": null,
                        "manufacturer": null,
                        "cruise_speed_kts": null,
                        "cruise_speed_knots": null,
                        "model": null,
                        "jetnet_lookup_attempted_at": null,
                        "current_status": "AVAILABLE",
                        "created_at": "2025-12-01T01:24:50.216587",
                        "image_urls": [
                            "/static/photos/N399WS/0.jpg",
                            "/static/photos/N399WS/1.jpg",
                            "/static/photos/N399WS/10.jpg",
                            "/static/photos/N399WS/11.jpg",
                            "/static/photos/N399WS/12.jpg",
                            "/static/photos/N399WS/13.jpg",
                            "/static/photos/N399WS/14.jpg",
                            "/static/photos/N399WS/15.jpg",
                            "/static/photos/N399WS/16.jpg",
                            "/static/photos/N399WS/17.jpg",
                            "/static/photos/N399WS/18.jpg",
                            "/static/photos/N399WS/19.jpg",
                            "/static/photos/N399WS/2.jpg",
                            "/static/photos/N399WS/20.jpg",
                            "/static/photos/N399WS/21.jpg",
                            "/static/photos/N399WS/3.jpg",
                            "/static/photos/N399WS/4.jpg",
                            "/static/photos/N399WS/5.jpg",
                            "/static/photos/N399WS/6.jpg",
                            "/static/photos/N399WS/7.jpg",
                            "/static/photos/N399WS/8.jpg",
                            "/static/photos/N399WS/9.jpg"
                        ],
                        "jetnet_exists": false,
                        "aircraft_id": "00083cb7-4596-420f-8946-b67cb5b4caf2",
                        "operator_id": "28fcb9b8-46b8-442b-b328-7c0e79faae59",
                        "last_maintenance": null,
                        "mfr_year": null,
                        "banner_image_url": null,
                        "jetnet_details_fetched_at": "2026-01-15T02:22:33.502107+00:00",
                        "tail_number": "N399WS",
                        "year": null,
                        "aw_date": null,
                        "description": null,
                        "aircraft_make_model_id": "8f4ebbfe-7e54-4bff-aae5-53d668f27dca",
                        "make_model": "BE-90-C90A",
                        "serial_number": "LJ-1547",
                        "next_maintenance_due": null,
                        "registered_owner": null,
                        "max_passengers": null,
                        "aircraft_type": null,
                        "insurance_expiry": null,
                        "registered_owner_state": null,
                        "range_nm": null,
                        "passenger_capacity": null,
                        "home_base": null,
                        "fractional_owner": false,
                        "aircraft_features": null,
                        "aircraft_amenities": null
                    }
                }
            ]
        },
        "acceptedOption": {
            "operator_id": "28fcb9b8-46b8-442b-b328-7c0e79faae59",
            "total_price": 0,
            "estimated_flight_time": 0,
            "platform_fee": 0,
            "aircraft_id": "00083cb7-4596-420f-8946-b67cb5b4caf2",
            "broker_markup": 0,
            "aircraft_features": {
                "beds": 1,
                "wifi": false,
                "entertainment": false
            },
            "status": "ACCEPTED",
            "bid_id": "553fc839-a0bd-4386-ba2b-3ac32c435909",
            "fuel_cost": 0,
            "final_price": 5.41,
            "shortlisted": true,
            "bid_option_id": "775022f6-c2e7-4f77-86ca-707edd2bd9df",
            "landing_fees": 0,
            "is_recommended": true,
            "created_at": "2026-04-15T02:31:49.387623",
            "crew_fees": 0,
            "recommendation_reason": ".",
            "updated_at": "2026-04-15T02:31:49.387623",
            "catering_cost": 0,
            "availability_confirmed": true,
            "federal_excise_tax": 0,
            "base_price": 0,
            "ground_transport": 0,
            "risk_level": "LOW",
            "segment_tax": 5.2,
            "other_fees": 0,
            "trust_score": 0,
            "operator_cost": 0,
            "operator": {
                "base_airport": null,
                "email": "jimhunt@eagleairmed.com",
                "external_sources": {},
                "trust_score": 96.38,
                "business_started_date": "1994-01-11T00:00:00",
                "website": "http://www.stanstednews.com/privacy.html",
                "rating_tiers": "Pinnacle",
                "trust_score_updated_at": "2026-01-09T00:50:03.316776",
                "argus_rating": "No",
                "faa_operator_name": "GUARDIAN FLIGHT, LLC.",
                "financial_health_score": 100,
                "wyvern_rating": "No",
                "faa_dsgn_code": "G1IA",
                "dba_name": null,
                "aoc_part135": "G1IA720A (Guardian Flight LLC)",
                "faa_ceo": "BURNS, CHRISTOPHER",
                "operator_id": "28fcb9b8-46b8-442b-b328-7c0e79faae59",
                "certificate_number": "G1IA720A",
                "regulatory_status": "COMPLIANT",
                "is_bao": "No",
                "faa_city": "LEWISVILLE",
                "ops_specs": null,
                "is_verified": true,
                "acsf_ias": "No",
                "faa_state": "TX",
                "name": "Guardian Flight, Llc.",
                "created_at": "2025-11-20T15:54:53.284428",
                "telephone": "+1 435 678 3222",
                "faa_pic_captains": "235"
            },
            "aircraft": {
                "range_nautical_miles": null,
                "hourly_rate": null,
                "manufacturer": null,
                "cruise_speed_kts": null,
                "cruise_speed_knots": null,
                "model": null,
                "jetnet_lookup_attempted_at": null,
                "current_status": "AVAILABLE",
                "created_at": "2025-12-01T01:24:50.216587",
                "image_urls": [
                    "/static/photos/N399WS/0.jpg",
                    "/static/photos/N399WS/1.jpg",
                    "/static/photos/N399WS/10.jpg",
                    "/static/photos/N399WS/11.jpg",
                    "/static/photos/N399WS/12.jpg",
                    "/static/photos/N399WS/13.jpg",
                    "/static/photos/N399WS/14.jpg",
                    "/static/photos/N399WS/15.jpg",
                    "/static/photos/N399WS/16.jpg",
                    "/static/photos/N399WS/17.jpg",
                    "/static/photos/N399WS/18.jpg",
                    "/static/photos/N399WS/19.jpg",
                    "/static/photos/N399WS/2.jpg",
                    "/static/photos/N399WS/20.jpg",
                    "/static/photos/N399WS/21.jpg",
                    "/static/photos/N399WS/3.jpg",
                    "/static/photos/N399WS/4.jpg",
                    "/static/photos/N399WS/5.jpg",
                    "/static/photos/N399WS/6.jpg",
                    "/static/photos/N399WS/7.jpg",
                    "/static/photos/N399WS/8.jpg",
                    "/static/photos/N399WS/9.jpg"
                ],
                "jetnet_exists": false,
                "aircraft_id": "00083cb7-4596-420f-8946-b67cb5b4caf2",
                "operator_id": "28fcb9b8-46b8-442b-b328-7c0e79faae59",
                "last_maintenance": null,
                "mfr_year": null,
                "banner_image_url": null,
                "jetnet_details_fetched_at": "2026-01-15T02:22:33.502107+00:00",
                "tail_number": "N399WS",
                "year": null,
                "aw_date": null,
                "description": null,
                "aircraft_make_model_id": "8f4ebbfe-7e54-4bff-aae5-53d668f27dca",
                "make_model": "BE-90-C90A",
                "serial_number": "LJ-1547",
                "next_maintenance_due": null,
                "registered_owner": null,
                "max_passengers": null,
                "aircraft_type": null,
                "insurance_expiry": null,
                "registered_owner_state": null,
                "range_nm": null,
                "passenger_capacity": null,
                "home_base": null,
                "fractional_owner": false,
                "aircraft_features": null,
                "aircraft_amenities": null
            }
        }
    },
    "passengers": [],
    "acceptedOption": {
        "departure_date": "2026-05-01T03:30:00",
        "valid_until": "2026-04-30T00:00:00",
        "updated_at": "2026-04-15T02:31:45.918573",
        "return_date": null,
        "sent_at": null,
        "passenger_count": 1,
        "viewed_at": null,
        "leg_itinerary": [
            {
                "pax": 1,
                "departure_date": "2026-05-01T03:30:00.000Z",
                "arrival_address": null,
                "arrival_airport": "KTEX",
                "departure_address": null,
                "departure_airport": "KTEB"
            }
        ],
        "bid_id": "553fc839-a0bd-4386-ba2b-3ac32c435909",
        "client_name": "Kervin Kervin",
        "baggage_requirements": "",
        "accepted_at": null,
        "client_email": "kgatchalian@trustjet.ai",
        "special_requests": "",
        "notes": "",
        "broker_id": "bedf3852-a2f2-4a7c-885c-4cce9d6ad067",
        "client_phone": "",
        "status": "DRAFT",
        "message_id": null,
        "trip_number": "T673362",
        "created_by": "bedf3852-a2f2-4a7c-885c-4cce9d6ad067",
        "departure_airport": "KTEB",
        "total_amount": 5.41,
        "broker_org_id": "94d76474-c055-4882-ab9d-651c29cf5fb9",
        "arrival_airport": "KTEX",
        "currency": "USD",
        "created_at": "2026-04-15T02:31:45.918573",
        "bid_options": [
            {
                "operator_id": "28fcb9b8-46b8-442b-b328-7c0e79faae59",
                "total_price": 0,
                "estimated_flight_time": 0,
                "platform_fee": 0,
                "aircraft_id": "00083cb7-4596-420f-8946-b67cb5b4caf2",
                "broker_markup": 0,
                "aircraft_features": {
                    "beds": 1,
                    "wifi": false,
                    "entertainment": false
                },
                "status": "ACCEPTED",
                "bid_id": "553fc839-a0bd-4386-ba2b-3ac32c435909",
                "fuel_cost": 0,
                "final_price": 5.41,
                "shortlisted": true,
                "bid_option_id": "775022f6-c2e7-4f77-86ca-707edd2bd9df",
                "landing_fees": 0,
                "is_recommended": true,
                "created_at": "2026-04-15T02:31:49.387623",
                "crew_fees": 0,
                "recommendation_reason": ".",
                "updated_at": "2026-04-15T02:31:49.387623",
                "catering_cost": 0,
                "availability_confirmed": true,
                "federal_excise_tax": 0,
                "base_price": 0,
                "ground_transport": 0,
                "risk_level": "LOW",
                "segment_tax": 5.2,
                "other_fees": 0,
                "trust_score": 0,
                "operator_cost": 0,
                "operator": {
                    "base_airport": null,
                    "email": "jimhunt@eagleairmed.com",
                    "external_sources": {},
                    "trust_score": 96.38,
                    "business_started_date": "1994-01-11T00:00:00",
                    "website": "http://www.stanstednews.com/privacy.html",
                    "rating_tiers": "Pinnacle",
                    "trust_score_updated_at": "2026-01-09T00:50:03.316776",
                    "argus_rating": "No",
                    "faa_operator_name": "GUARDIAN FLIGHT, LLC.",
                    "financial_health_score": 100,
                    "wyvern_rating": "No",
                    "faa_dsgn_code": "G1IA",
                    "dba_name": null,
                    "aoc_part135": "G1IA720A (Guardian Flight LLC)",
                    "faa_ceo": "BURNS, CHRISTOPHER",
                    "operator_id": "28fcb9b8-46b8-442b-b328-7c0e79faae59",
                    "certificate_number": "G1IA720A",
                    "regulatory_status": "COMPLIANT",
                    "is_bao": "No",
                    "faa_city": "LEWISVILLE",
                    "ops_specs": null,
                    "is_verified": true,
                    "acsf_ias": "No",
                    "faa_state": "TX",
                    "name": "Guardian Flight, Llc.",
                    "created_at": "2025-11-20T15:54:53.284428",
                    "telephone": "+1 435 678 3222",
                    "faa_pic_captains": "235"
                },
                "aircraft": {
                    "range_nautical_miles": null,
                    "hourly_rate": null,
                    "manufacturer": null,
                    "cruise_speed_kts": null,
                    "cruise_speed_knots": null,
                    "model": null,
                    "jetnet_lookup_attempted_at": null,
                    "current_status": "AVAILABLE",
                    "created_at": "2025-12-01T01:24:50.216587",
                    "image_urls": [
                        "/static/photos/N399WS/0.jpg",
                        "/static/photos/N399WS/1.jpg",
                        "/static/photos/N399WS/10.jpg",
                        "/static/photos/N399WS/11.jpg",
                        "/static/photos/N399WS/12.jpg",
                        "/static/photos/N399WS/13.jpg",
                        "/static/photos/N399WS/14.jpg",
                        "/static/photos/N399WS/15.jpg",
                        "/static/photos/N399WS/16.jpg",
                        "/static/photos/N399WS/17.jpg",
                        "/static/photos/N399WS/18.jpg",
                        "/static/photos/N399WS/19.jpg",
                        "/static/photos/N399WS/2.jpg",
                        "/static/photos/N399WS/20.jpg",
                        "/static/photos/N399WS/21.jpg",
                        "/static/photos/N399WS/3.jpg",
                        "/static/photos/N399WS/4.jpg",
                        "/static/photos/N399WS/5.jpg",
                        "/static/photos/N399WS/6.jpg",
                        "/static/photos/N399WS/7.jpg",
                        "/static/photos/N399WS/8.jpg",
                        "/static/photos/N399WS/9.jpg"
                    ],
                    "jetnet_exists": false,
                    "aircraft_id": "00083cb7-4596-420f-8946-b67cb5b4caf2",
                    "operator_id": "28fcb9b8-46b8-442b-b328-7c0e79faae59",
                    "last_maintenance": null,
                    "mfr_year": null,
                    "banner_image_url": null,
                    "jetnet_details_fetched_at": "2026-01-15T02:22:33.502107+00:00",
                    "tail_number": "N399WS",
                    "year": null,
                    "aw_date": null,
                    "description": null,
                    "aircraft_make_model_id": "8f4ebbfe-7e54-4bff-aae5-53d668f27dca",
                    "make_model": "BE-90-C90A",
                    "serial_number": "LJ-1547",
                    "next_maintenance_due": null,
                    "registered_owner": null,
                    "max_passengers": null,
                    "aircraft_type": null,
                    "insurance_expiry": null,
                    "registered_owner_state": null,
                    "range_nm": null,
                    "passenger_capacity": null,
                    "home_base": null,
                    "fractional_owner": false,
                    "aircraft_features": null,
                    "aircraft_amenities": null
                }
            }
        ]
    },
    "flights": [
        {
            "pax": 1,
            "departure_date": "2026-05-01T03:30:00.000Z",
            "arrival_address": null,
            "arrival_airport": "KTEX",
            "departure_address": null,
            "departure_airport": "KTEB"
        }
    ],
    "organizationName": "AVSKY CHARTER VENTURES, INC."
};
